"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyUser = exports.isMultiKind = exports.isSingleKind = void 0;
const validators_1 = require("../../validators");
/**
 * Check if a context is a single kind context.
 * @param context
 * @returns true if the context is a single kind context.
 */
function isSingleKind(context) {
    if ('kind' in context) {
        return validators_1.TypeValidators.String.is(context.kind) && context.kind !== 'multi';
    }
    return false;
}
exports.isSingleKind = isSingleKind;
/**
 * Check if a context is a multi-kind context.
 * @param context
 * @returns true if it is a multi-kind context.
 */
function isMultiKind(context) {
    if ('kind' in context) {
        return validators_1.TypeValidators.String.is(context.kind) && context.kind === 'multi';
    }
    return false;
}
exports.isMultiKind = isMultiKind;
/**
 * Check if a context is a legacy user context.
 * @param context
 * @returns true if it is a legacy user context.
 */
function isLegacyUser(context) {
    return !('kind' in context) || context.kind === null || context.kind === undefined;
}
exports.isLegacyUser = isLegacyUser;
//# sourceMappingURL=index.js.map